import { render, staticRenderFns } from "./Bestellung.vue?vue&type=template&id=5d12301b&"
import script from "./Bestellung.vue?vue&type=script&lang=js&"
export * from "./Bestellung.vue?vue&type=script&lang=js&"
import style0 from "./Bestellung.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports